import { NAV_PRECISION, RUPEE_SYMBOL } from '../constants/common';

export const getReturns = (investedValue: string | number, currentValue: string | number) => {
  return formatMoney(Number(currentValue) - Number(investedValue));
};

export const isReturnPositive = (returnValue?: string | number) => {
  if (!(returnValue + '')) {
    return false;
  }
  return (
    Number((returnValue + '').replace(/%/g, '').replace(/,/g, '').replace(/ /g, '').replace(RUPEE_SYMBOL, '')) >= 0
  );
};

export const getReturnsPercentage = (investedValue: string | number, currentValue: string | number) => {
  const diff = Number(currentValue) - Number(investedValue);
  return `${((diff / Number(investedValue)) * 100 || 0).toFixed(2)} %`;
};

export const formatReturn = (returnValue: string | number) => {
  return `${Number(returnValue).toFixed(2)}%`;
};

export const formatMoney = (value: string | number | undefined | null, decimalPoints: number = 2) => {
  return Number(value) < 0 && value.toString().slice(0, 1) === '-'
    ? `${RUPEE_SYMBOL} -${numberWithCommas(Number(value.toString().slice(1) || 0).toFixed(decimalPoints))}`
    : `${RUPEE_SYMBOL} ${numberWithCommas(Number(value || 0).toFixed(decimalPoints))}`;
};

export const formatMoneySIP = (value: string | number | undefined | null, decimalPoints: number = 0) => {
  return Number(value) < 0 && value.toString().slice(0, 1) === '-'
    ? `${RUPEE_SYMBOL} -${numberWithCommas(Number(value.toString().slice(1) || 0).toFixed(decimalPoints))}`
    : `${RUPEE_SYMBOL} ${numberWithCommas(Number(value || 0).toFixed(decimalPoints))}`;
};

export const formatMoneyWithoutRupeeSymbol = (value: string | number | undefined | null, decimalPoints: number = 2) => {
  if(value === "") return value;
  return Number(value) < 0 && value.toString().slice(0, 1) === '-'
    ? `-${numberWithCommas(Number(value.toString().slice(1) || 0).toFixed(decimalPoints))}`
    : `${numberWithCommas(Number(value || 0).toFixed(decimalPoints))}`;
};

export const deformatMoney = (value: string) => {
  // Remove all occurrences of alphabets, commas, any special characters and the Rupee symbol from user input
  return Number(
    value
      .replace(/[a-zA-Z]/g, '')
      .replace(/,/g, '')
      .replace(/\W|_/g, '')
      .replace(RUPEE_SYMBOL, '')
  );
};

export const formatNavValue = (value: string | number, precision?: number) => {
  return Number(value).toFixed(precision ? precision : NAV_PRECISION);
};

export const numberWithCommas = (number: number | string) => {
  return number.toString().split('.')[0].length > 3
    ? number
        .toString()
        .substring(0, number.toString().split('.')[0].length - 3)
        .replace(/\B(?=(\d{2})+(?!\d))/g, ',') +
        ',' +
        number.toString().substring(number.toString().split('.')[0].length - 3)
    : number.toString();
};

export const getSIPAmount = (
  amount: number | any,
  years: number | any,
  expectedReturn: number | any,
  inflationRate: number | any
) => {
  const numOfYears = years - new Date().getFullYear();
  const numOfMonths = numOfYears * 12;
  const monthlyExpectedReturn = expectedReturn / 12 / 100;
  // To calculate the future value of the the amount considering the inflation rate
  const inflationAdjustedFutureValue = amount * Math.pow(1 + inflationRate / 100, numOfYears);
  // To calculate monthly sip amount
  const sipAmount =
    (inflationAdjustedFutureValue * monthlyExpectedReturn) / (Math.pow(1 + monthlyExpectedReturn, numOfMonths) - 1);
  if (sipAmount > 0) {
    return formatMoney(sipAmount, 0);
  } else {
    // For negative sip amount use Rs.0
    return formatMoney(0, 0);
  }
};

export const formatReturnValue = (value: string | Number, numberOfDecimalPlaces: number) => {
  return Number(value).toFixed(numberOfDecimalPlaces);
};
